import { types as t } from 'mobx-state-tree';

export default t.model("Stock", {
	Sku: t.string,
	Quantity: t.number,
    StockAlias: t.string
	//FirstDeliveryDate: t.string

});